import { render } from "./Point.vue?vue&type=template&id=c5ab9c06&ts=true"
import script from "./Point.vue?vue&type=script&lang=ts"
export * from "./Point.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__